import { useEffect, useState } from "react";
import { Spinner } from "@/components/ui/spinner";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2, XCircle, AlertCircle } from "lucide-react";

function StopReminders() {
  const [status, setStatus] = useState<
    "loading" | "success" | "error" | "invalid"
  >("loading");
  const [errorMessage, setErrorMessage] = useState<string>("We couldn’t process your request. Please try again later.");
  const [successMessage, setSuccessMessage] = useState<string>("You’ll no longer receive reminder email from this service. Thanks for letting us know.");
  
  useEffect(() => {
    const userId = new URL(window.location.href).searchParams.get("userId");
    const type = new URL(window.location.href).searchParams.get("type");

    if (!userId || !type) {
      setStatus("invalid");
      return;
    }

    fetch(`/api/unsubscribe?userId=${userId}&type=${type}`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to unsubscribe");
        return res.json();
      })
      .then((response) => {
        setStatus("success");
        setSuccessMessage(response.message);
      })
      .catch((error) => {
        setStatus("error");
        setErrorMessage(error.message);
      });
  }, []);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-50 px-4">
      <Card className="w-full max-w-md shadow-md rounded-2xl">
        <CardContent className="flex flex-col items-center justify-center py-10 text-center space-y-4">
          {status === "loading" && (
            <>
              <Spinner className="w-10 h-10 text-blue-500" />
              <p className="text-gray-700 font-medium">
                Processing your request...
              </p>
            </>
          )}

          {status === "success" && (
            <>
              <CheckCircle2 className="w-12 h-12 text-green-500" />
              <h2 className="text-xl font-semibold text-green-700">
                You’re unsubscribed 
              </h2>
              <p className="text-gray-600">
                {successMessage}
              </p>
            </>
          )}

          {status === "error" && (
            <>
              <XCircle className="w-12 h-12 text-red-500" />
              <h2 className="text-xl font-semibold text-red-700">
                Something went wrong
              </h2>
              <p className="text-gray-600">
                {errorMessage}
              </p>
            </>
          )}

          {status === "invalid" && (
            <>
              <AlertCircle className="w-12 h-12 text-gray-500" />
              <h2 className="text-xl font-semibold text-gray-700">
                Invalid link
              </h2>
              <p className="text-gray-600">
                This unsubscribe link is not valid or has expired.
              </p>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export default StopReminders;
